export const TRIGGER_VIDEO_CHANGE = 'TRIGGER-VIDEO-CHANGE'

export const future = 'constants go here'
